<!--
 * @Author: 
 * @LastEditTime: 2022-07-26 17:09:56
 * @Description: 
-->
<template>
  <div class="circle-item">
    <img src="../images/nowTime.png" alt="" />
    <span class="nowTime fz-18">{{ nowTimes }}</span>
  </div>
</template>

<script>
export default {
  name: 'videoCamera',
  props: {
    nowTime: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      nowTimes: '', //当前时间
    }
  },
  watch: {
    nowTime(val) {
      this.nowTimes = val
    },
  },
}
</script>

<style lang="scss" scoped>

.circle-item {
  position: relative;
  .nowTime {
    position: absolute;
    bottom: 10px;
    right: 5px;
    -webkit-text-stroke: 1.2px rgb(0, 0, 0);
    color: #eee;
  }
}
@import './specialStyle.scss';

</style>
